import { AuthUser } from 'aws-amplify/auth'

const init = () => {
  const gaId = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID
  if (!gaId) return

  // load gtag.js:  https://developers.google.com/analytics/devguides/collection/gtagjs
  const script1 = document.createElement('script')
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`
  script1.async = true
  document.body.appendChild(script1)

  const script2 = document.createElement('script')
  script2.text = `window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${gaId}');`
  document.body.appendChild(script2)
}

const logPageView = (url: string) => {
  const gaId = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID
  if (!gaId) return
  if (typeof window.gtag !== 'function') return

  window.gtag('config', gaId, {
    page_path: url,
  })
}

const setUser = (authUser: AuthUser | null) => {
  const gaId = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID
  if (!gaId) return
  if (typeof window.gtag !== 'function') return
  if (!authUser) return

  const { userId } = authUser
  const email = authUser.signInDetails?.loginId ?? ''
  const domain = email.split('@')[1] || ''

  window.gtag('config', gaId, {
    user_id: userId,
  })

  window.gtag('set', {
    user_properties: {
      email,
      domain,
    },
  })
}

export default { init, logPageView, setUser }
